import Vue from 'vue';

export const routerEventBus = new Vue();
export const EventBus = routerEventBus;
